<div class="radio-group" [class.radio-group--business]="isBusinessMobile" [class.disabled]="disabled">
  <div class="radio-group__label" *ngIf="label">
    <img
      src="assets/icons/required-asterisk.svg"
      *ngIf="required"
      [attr.alt]="'alt.requiredField' | translate"
    >
    {{ label }}
  </div>
  <div class="radio-group__list">
    <button
      type="button"
      class="radio-group__item"
      *ngFor="let option of options; trackBy: trackByOption"
      [disabled]="disabled"
      (click)="selectOption(option)"
    >
      <span class="radio-group__text">{{ getOptionDisplayText(option) }}</span>
      <span class="radio-group__icon">
        <svg *ngIf="!isSelected(option)" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.7"/>
        </svg>
        <svg *ngIf="isSelected(option)" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.7"/>
          <circle cx="12" cy="12" r="5" fill="currentColor"/>
        </svg>
      </span>
    </button>

    <div class="radio-group__empty" *ngIf="!options.length">
      Ничего не найдено
    </div>
  </div>
</div>
